module.exports = __webpack_public_path__ + "media/newstyle/images/room-circle-09e831eefcde0159fcbdac4b95362c25.svg";